module.exports = __webpack_public_path__ + "img/info.3aea435e.svg";